import React, { useState, useEffect } from "react";
import ReactSwitch from "react-switch";
import Swal from "sweetalert2";
import { apiRequest } from "../../apiServices/allApi";
import "../../../assets/css/Dashboard.css";

const Gateway = () => {
  // Box 1: UPI Gateway (isUpiGateway, upiGatewayMin, upiGatewayMax)
  const [isUpiGateway, setIsUpiGateway] = useState(true);
  const [upiGatewayMin, setUpiGatewayMin] = useState(0);
  const [upiGatewayMax, setUpiGatewayMax] = useState(0);

  // Box 2: UPI Gateway 02 (isUpiGateway02, upiGatewayMin2, upiGatewayMax2)
  const [isUpiGateway02, setIsUpiGateway02] = useState(true);
  const [upiGatewayMin2, setUpiGatewayMin2] = useState(0);
  const [upiGatewayMax2, setUpiGatewayMax2] = useState(0);

  // Box 3: Gateway 1 / PayinOne (payinOne, payinMin, payinMax)
  const [payinOne, setPayinOne] = useState(true);
  const [payinMin, setPayinMin] = useState(0);
  const [payinMax, setPayinMax] = useState(0);

  // Box 4: WhatsApp Deposit (whatsappDeposit, whatsappDepositNo, whatsappRangemin, whatsappRangemax)
  const [whatsappDeposit, setWhatsappDeposit] = useState(false);
  const [whatsappDepositNo, setWhatsappDepositNo] = useState("");
  const [whatsappRangemin, setWhatsappRangemin] = useState(0);
  const [whatsappRangemax, setWhatsappRangemax] = useState(0);

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await apiRequest("gatewaysettings/data", "GET");
        const data = res?.data;
        if (data) {
          setIsUpiGateway(
            typeof data.isUpiGateway !== "undefined"
              ? Boolean(data.isUpiGateway)
              : true,
          );
          setUpiGatewayMin(data.upiGatewayMin ?? 0);
          setUpiGatewayMax(data.upiGatewayMax ?? 0);

          setIsUpiGateway02(
            typeof data.isUpiGateway02 !== "undefined"
              ? Boolean(data.isUpiGateway02)
              : true,
          );
          setUpiGatewayMin2(data.upiGatewayMin2 ?? 0);
          setUpiGatewayMax2(data.upiGatewayMax2 ?? 0);

          setPayinOne(
            typeof data.payinOne !== "undefined"
              ? Boolean(data.payinOne)
              : true,
          );
          setPayinMin(data.payinMin ?? 0);
          setPayinMax(data.payinMax ?? 0);

          setWhatsappDeposit(Boolean(data.whatsappDeposit));
          setWhatsappDepositNo(data.whatsappDepositNo ?? "");
          setWhatsappRangemin(data.whatsappRangemin ?? 0);
          setWhatsappRangemax(data.whatsappRangemax ?? 0);
        }
      } catch (error) {
        console.error("Error fetching gateway settings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleGeneralSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const payload = {
      isUpiGateway,
      upiGatewayMin,
      upiGatewayMax,
      isUpiGateway02,
      upiGatewayMin2,
      upiGatewayMax2,
      payinOne,
      payinMin,
      payinMax,
      whatsappDeposit,
      whatsappDepositNo,
      whatsappRangemin,
      whatsappRangemax,
    };

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest("gatewaysettings", "POST", payload, headers);
      if (res?.data?.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          text: "Gateway settings updated successfully.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Failed to update gateway settings.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while saving gateway settings.",
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return null;
  }

  return (
    <div className="admin-main-card mt-4 mb-5">
      <div className="admin-card-header">
        <h4 className="admin-card-title">
          <i className="mdi mdi-credit-card-settings text-primary"></i> Payment
          Gateway Configurations
        </h4>
        <span className="badge badge-success px-3 py-2">Deposit Channels</span>
      </div>

      <div className="card-body p-4 bg-white">
        <form onSubmit={handleGeneralSubmit}>
          <div className="row">
            {/* Box 1: UPI Gateway 1 */}
            {/* <div className="col-lg-6 mb-4">
              <div className="settings-box-card">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <div className="d-flex align-items-center">
                    <div
                      className="dashboard_card_icon bg-purple mr-3"
                      style={{
                        width: "36px",
                        height: "36px",
                        fontSize: "18px",
                      }}
                    >
                      <i className="mdi mdi-qrcode-scan"></i>
                    </div>
                    <div>
                      <h5 className="mb-0 text-dark font-weight-bold">
                        UPI Gateway 1
                      </h5>
                      <small className="text-muted">
                        Primary UPI Deposit Channel
                      </small>
                    </div>
                  </div>
                  <span
                    className={`badge ${isUpiGateway ? "badge-success" : "badge-secondary"}`}
                  >
                    {isUpiGateway ? "ACTIVE" : "DISABLED"}
                  </span>
                </div>

                <div className="settings-row">
                  <span className="settings-label">Gateway Status</span>
                  <ReactSwitch
                    checked={isUpiGateway}
                    onChange={setIsUpiGateway}
                    onColor="#0284c7"
                    offColor="#cbd5e1"
                    height={22}
                    width={44}
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Minimum Deposit (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={upiGatewayMin}
                    onChange={(e) => setUpiGatewayMin(e.target.value)}
                    placeholder="0"
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Maximum Deposit (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={upiGatewayMax}
                    onChange={(e) => setUpiGatewayMax(e.target.value)}
                    placeholder="0"
                  />
                </div>
              </div>
            </div> */}

            {/* Box 2: UPI Gateway 2 */}
            {/* <div className="col-lg-6 mb-4">
              <div className="settings-box-card">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <div className="d-flex align-items-center">
                    <div
                      className="dashboard_card_icon bg-blue mr-3"
                      style={{
                        width: "36px",
                        height: "36px",
                        fontSize: "18px",
                      }}
                    >
                      <i className="mdi mdi-cellphone-wireless"></i>
                    </div>
                    <div>
                      <h5 className="mb-0 text-dark font-weight-bold">
                        UPI Gateway 2
                      </h5>
                      <small className="text-muted">
                        Secondary UPI Deposit Channel
                      </small>
                    </div>
                  </div>
                  <span
                    className={`badge ${isUpiGateway02 ? "badge-success" : "badge-secondary"}`}
                  >
                    {isUpiGateway02 ? "ACTIVE" : "DISABLED"}
                  </span>
                </div>

                <div className="settings-row">
                  <span className="settings-label">Gateway Status</span>
                  <ReactSwitch
                    checked={isUpiGateway02}
                    onChange={setIsUpiGateway02}
                    onColor="#0284c7"
                    offColor="#cbd5e1"
                    height={22}
                    width={44}
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Minimum Deposit (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={upiGatewayMin2}
                    onChange={(e) => setUpiGatewayMin2(e.target.value)}
                    placeholder="0"
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Maximum Deposit (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={upiGatewayMax2}
                    onChange={(e) => setUpiGatewayMax2(e.target.value)}
                    placeholder="0"
                  />
                </div>
              </div>
            </div> */}

            {/* Box 3: IMB Gateway */}
            <div className="col-lg-6 mb-4">
              <div className="settings-box-card">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <div className="d-flex align-items-center">
                    <div
                      className="dashboard_card_icon bg-cyan mr-3"
                      style={{
                        width: "36px",
                        height: "36px",
                        fontSize: "18px",
                      }}
                    >
                      <i className="mdi mdi-cash-register"></i>
                    </div>
                    <div>
                      <h5 className="mb-0 text-dark font-weight-bold">
                        IMB Gateway
                      </h5>
                      <small className="text-muted">
                        Online PG Deposit Integration
                      </small>
                    </div>
                  </div>
                  <span
                    className={`badge ${payinOne ? "badge-success" : "badge-secondary"}`}
                  >
                    {payinOne ? "ACTIVE" : "DISABLED"}
                  </span>
                </div>

                <div className="settings-row">
                  <span className="settings-label">Gateway Status</span>
                  <ReactSwitch
                    checked={payinOne}
                    onChange={setPayinOne}
                    onColor="#0284c7"
                    offColor="#cbd5e1"
                    height={22}
                    width={44}
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Minimum Amount (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={payinMin}
                    onChange={(e) => setPayinMin(e.target.value)}
                    placeholder="0"
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Maximum Amount (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={payinMax}
                    onChange={(e) => setPayinMax(e.target.value)}
                    placeholder="0"
                  />
                </div>
              </div>
            </div>

            {/* Box 4: WhatsApp Deposit */}
            <div className="col-lg-6 mb-4">
              <div className="settings-box-card">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <div className="d-flex align-items-center">
                    <div
                      className="dashboard_card_icon bg-green mr-3"
                      style={{
                        width: "36px",
                        height: "36px",
                        fontSize: "18px",
                      }}
                    >
                      <i className="mdi mdi-whatsapp"></i>
                    </div>
                    <div>
                      <h5 className="mb-0 text-dark font-weight-bold">
                        WhatsApp Direct Deposit
                      </h5>
                      <small className="text-muted">
                        Direct WhatsApp Chat Support Deposit
                      </small>
                    </div>
                  </div>
                  <span
                    className={`badge ${whatsappDeposit ? "badge-success" : "badge-secondary"}`}
                  >
                    {whatsappDeposit ? "ACTIVE" : "DISABLED"}
                  </span>
                </div>

                <div className="settings-row">
                  <span className="settings-label">Deposit Status</span>
                  <ReactSwitch
                    checked={whatsappDeposit}
                    onChange={setWhatsappDeposit}
                    onColor="#0284c7"
                    offColor="#cbd5e1"
                    height={22}
                    width={44}
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">WhatsApp Number</span>
                  <input
                    type="text"
                    className="form-control settings-input-sm"
                    value={whatsappDepositNo}
                    onChange={(e) => setWhatsappDepositNo(e.target.value)}
                    placeholder="+91..."
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Minimum Amount (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={whatsappRangemin}
                    onChange={(e) => setWhatsappRangemin(e.target.value)}
                    placeholder="0"
                  />
                </div>

                <div className="settings-row">
                  <span className="settings-label">Maximum Amount (₹)</span>
                  <input
                    type="number"
                    className="form-control settings-input-sm"
                    value={whatsappRangemax}
                    onChange={(e) => setWhatsappRangemax(e.target.value)}
                    placeholder="0"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* SAVE BUTTON */}
          <div className="d-flex justify-content-end mt-2">
            <button
              type="submit"
              disabled={saving}
              className="btn btn-primary-gradient px-5 py-3"
            >
              <i className="mdi mdi-content-save mr-2"></i>
              {saving ? "Saving Changes..." : "Save Gateway Settings"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Gateway;
